import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockYoutubeplayIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockYoutubeplay",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.49 22.78c-.3 1.49-1.5 2.63-3 2.82h-.02c-2.63.26-5.69.41-8.78.41-.59 0-1.18 0-1.77-.02h.09c-.53.01-1.15.02-1.77.02-3.07 0-6.1-.15-9.1-.43l.38.03a3.59 3.59 0 0 1-3.02-2.8v-.02c-.31-1.7-.49-3.65-.49-5.64 0-.4 0-.8.02-1.2v.06c-.02-.36-.03-.79-.03-1.21 0-1.97.19-3.9.55-5.76l-.03.19a3.56 3.56 0 0 1 3-2.83h.02c2.61-.26 5.64-.41 8.71-.41.62 0 1.24 0 1.85.02h-.09c.53-.01 1.15-.02 1.77-.02 3.07 0 6.1.15 9.1.43l-.38-.03c1.5.22 2.69 1.35 2.99 2.81v.02c.33 1.69.51 3.63.51 5.62 0 .41 0 .82-.02 1.22V16c.02.37.03.8.03 1.24 0 1.96-.19 3.87-.54 5.72l.03-.19Zm-7.93-7.62-8.04-5.01a1.07 1.07 0 0 0-1.02 0c-.28.18-.46.48-.47.83v10c0 .37.2.7.5.88.14.08.31.12.48.12h.03c.18 0 .36-.06.5-.16s7.96-4.99 7.96-4.99c.28-.18.47-.49.47-.84v-.03a.99.99 0 0 0-.42-.8Z"
    })
  }));
};
SocialBlockYoutubeplayIcon.displayName = 'SocialBlockYoutubeplayIcon';